import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Norwegian Personalnummer generator following Single Responsibility Principle
 */
export class PersonalnummerGenerator extends BaseGenerator {
  generate(options = {}) {
    const { birthDate = null } = options;

    let ddmmyy;
    if (birthDate) {
      const date = new Date(birthDate);
      const day = this.padZero(date.getDate(), 2);
      const month = this.padZero(date.getMonth() + 1, 2);
      const year = date.getFullYear().toString().slice(-2);
      ddmmyy = day + month + year;
    } else {
      const day = this.padZero(this.randomInt(1, 28), 2);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const year = this.padZero(this.randomInt(0, 99), 2);
      ddmmyy = day + month + year;
    }

    // Generate individual number (3 digits)
    const individualNumber = this.randomDigits(3);

    // Calculate check digits
    const partial = ddmmyy + individualNumber;
    
    // First check digit
    const weights1 = [3, 7, 6, 1, 8, 9, 4, 5, 2];
    let sum1 = 0;
    for (let i = 0; i < 9; i++) {
      sum1 += parseInt(partial[i]) * weights1[i];
    }
    const checkDigit1 = 11 - (sum1 % 11);
    const firstCheck = checkDigit1 === 11 ? 0 : checkDigit1;

    // Second check digit
    const withFirstCheck = partial + firstCheck;
    const weights2 = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let sum2 = 0;
    for (let i = 0; i < 10; i++) {
      sum2 += parseInt(withFirstCheck[i]) * weights2[i];
    }
    const checkDigit2 = 11 - (sum2 % 11);
    const secondCheck = checkDigit2 === 11 ? 0 : checkDigit2;

    return withFirstCheck + secondCheck;
  }
}